function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 3025.1143 3024.2661",
    ref: svgRef
  }, props), React.createElement("path", {
    style: {
      fill: "currentColor",
      stroke: "none",
      strokeWidth: 25
    },
    d: "m 1156.5,1437.1029 h 281 v -281 c 0,-41 34,-75 75,-75 v 0 c 41,0 75,34 75,75 v 281 h 281 c 41,0 75,34 75,75 v 0 c 0,41 -34,75 -75,75 h -281 v 281 c 0,41 -34,75 -75,75 v 0 c -41,0 -75,-34 -75,-75 v -281 h -281 c -41,0 -75,-34 -75,-75 v 0 c 0,-41 34,-75 75,-75 z"
  }), React.createElement("path", {
    style: {
      fill: "currentColor",
      stroke: "none",
      strokeWidth: 25
    },
    d: "m 785.5,853.1029 c 0,48 58,129 142,43 24,-23 35,-32 61,-53 258,-213 657,-239 945,-69 14,8 22,11 34,18 79,49 184,148 237,226 l 77,128 c 108,226 108,498 2,727 -126,273 -429,488 -733,488 -249,0 -454,-64 -634,-244 -69,-69 -125,-143 -169,-233 -109,-222 -110,-472 -19,-701 17,-41 59,-99 16,-146 -20,-22 -82,-34 -116,15 -67,92 -116,344 -116,475 0,83 19,192 42,262 20,61 41,122 71,179 6,13 13,25 21,39 l 155,202 c 80,88 191,165 302,213 467,204 942,48 1229,-340 l 68,-114 c 9,-16 15,-32 22,-46 168,-347 90,-761 -143,-1048 -20,-24 -40,-45 -62,-67 -20,-20 -39,-38 -63,-58 -72,-62 -142,-107 -232,-147 -293,-128 -552,-114 -841,9 -68,29 -296,177 -296,242 z"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus.743a6d65.svg";
export { ForwardRef as ReactComponent };